















import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EventField",
  props: {
    invalid: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    invalidClass() {
      return {
        "eventField--invalid": this.invalid
      };
    }
  },
  methods: {
    updateValue(event: Event) {
      if (event.target instanceof HTMLInputElement) {
        this.$emit("input", event.target.value);
        this.$emit("change", event.target.value);
      }
    }
  }
});
